import React, { Fragment, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Row, Col } from 'antd';
import Title from 'antd/es/typography/Title';
import Text from 'antd/es/typography/Text';
import unescape from "lodash/unescape";
import './styles.css';

export default forwardRef((props: any, ref: any) => {
  const { inputData, language } = props,
    { questions } = inputData;
  const dangerouslySetInnerHTML = unescape(questions[language]);

  return (
    <FormItem
      style={{ textAlign: "left" }}
      colon={false}
    >
      <Row type="flex" justify="center" gutter={[16,0]}>
        <Col>
          <Title type="secondary" level={2}>Example:</Title>
        </Col>
        <Col style={{ whiteSpace: 'pre' }}>
          <span dangerouslySetInnerHTML={{__html: dangerouslySetInnerHTML}} />
        </Col>
      </Row>
    </FormItem>
  );
});
